/**
 * Sprint 12+M5.11 (19.07.2026) — Pionier-Route ErrorBoundary
 *
 * Fängt beliebige React-Renderfehler in Pionier-Routen auf und redirected zu
 * `/warteliste/one-click` statt „weißer Seite" oder Free/Paid-Login-Fallback.
 *
 * WARUM ein separater Boundary (statt globaler App-Boundary)?
 * - Free/Paid-Nutzer sollen bei Fehlern auf `/login` oder `/dashboard` bleiben.
 * - Pionier-Nutzer sollen bei Fehlern zurueck auf die Pionier-Bridge, damit
 *   sie den Magic-Link-Flow neu starten koennen — kein Absturz ins Free-Flow.
 */
import React from "react";
import { Navigate } from "react-router-dom";

export default class PionierErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Sprint 12+M5.17-g (22.07.2026) — Erweitertes Prod-Logging.
    // Falls diese Boundary den Redirect zu /warteliste/one-click triggert,
    // sehen wir in der Prod-Console genau, welche Komponente + welche Zeile
    // wirft. Bewusst kein Sentry — kurzfristiger Hotfix-Debug.
    // eslint-disable-next-line no-console
    console.error(
      "[PionierErrorBoundary] CAUGHT — redirect to /warteliste/one-click.\n" +
      "  error: " + (error && error.message ? error.message : String(error)) + "\n" +
      "  stack: " + (error && error.stack ? error.stack.split("\n").slice(0, 5).join("\n  ") : "n/a") + "\n" +
      "  componentStack: " + (info?.componentStack ? info.componentStack.split("\n").slice(0, 5).join("\n  ") : "n/a"),
    );
  }

  render() {
    if (this.state.hasError) {
      return <Navigate to="/warteliste/one-click" replace />;
    }
    return this.props.children;
  }
}
